// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const CHART_VIEW_STEP_SHAPES = [
  {
    stepType: PipelineStepType.CHART_VIEW,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {
      'Input dataset': {
        systemName: 'Input dataset',
        displayName: 'Input dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      }
    },
    outputDataShapes: {
      'Output dataset': {
        systemName: 'Output dataset',
        displayName: 'Output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: true
      },
      'Sampled output dataset': {
        systemName: 'Sampled output dataset',
        displayName: 'Sampled output dataset',
        kind: PipelineStepDataKind.DATASET,
        isMulti: false,
        isRequired: false
      },
      'Output chart': {
        systemName: 'Output chart',
        displayName: 'Output chart',
        kind: PipelineStepDataKind.CHART,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      chartConfig: {
        kind: 'taggedUnion',
        required: true,
        tagKey: 'type',
        choices: [
          {
            kind: 'shape',
            required: true,
            fields: {
              type: {
                kind: 'string',
                required: true,
                value: 'BAR_CHART'
              },
              parameters: {
                kind: 'shape',
                required: true,
                fields: {
                  barChartType: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'STANDARD',
                      'STACKED'
                    ]
                  },
                  seriesColumnName: {
                    kind: 'columnReference',
                    required: false,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  sortDirection: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'ASCENDING',
                      'DESCENDING'
                    ]
                  },
                  tryConvertStrings: {
                    kind: 'boolean',
                    required: false
                  },
                  fillNullsWithDefaultValues: {
                    kind: 'boolean',
                    required: false
                  },
                  xAxisColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  yAxisColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  yAxisMin: {
                    kind: 'number',
                    required: false
                  },
                  yAxisMax: {
                    kind: 'number',
                    required: false
                  },
                  yAxisScale: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'LINEAR',
                      'LOG'
                    ]
                  },
                  annotationLineConfigs: {
                    kind: 'array',
                    required: false,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        intercept: {
                          kind: 'number',
                          required: false
                        },
                        slope: {
                          kind: 'number',
                          required: false
                        },
                        direction: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'HORIZONTAL',
                            'VERTICAL'
                          ]
                        },
                        columnName: {
                          kind: 'columnReference',
                          required: false,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        valueMode: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'MANUAL',
                            'FROM_COLUMN'
                          ]
                        },
                        color: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'WHITE',
                            'BLACK',
                            'GREEN',
                            'GRAY',
                            'BLUE'
                          ]
                        },
                        hexColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        dash: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'SOLID',
                            'DASH',
                            'DOT',
                            'DASHDOT'
                          ]
                        },
                        lineLabel: {
                          kind: 'string',
                          required: false
                        }
                      }
                    }
                  },
                  xAxisLabel: {
                    kind: 'string',
                    required: false
                  },
                  yAxisLabel: {
                    kind: 'string',
                    required: false
                  },
                  discreteColorPalette: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'BENCHLING',
                      'DARK24',
                      'LIGHT24',
                      'BOLD',
                      'PASTEL',
                      'SAFE',
                      'PRISM'
                    ]
                  },
                  seriesColorConfigs: {
                    kind: 'array',
                    required: false,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        series: {
                          kind: 'string',
                          required: false
                        },
                        color: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        borderColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        errorBarColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        }
                      }
                    }
                  },
                  errorBarColumnName: {
                    kind: 'columnReference',
                    required: false,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  showLegend: {
                    kind: 'boolean',
                    required: false
                  },
                  legendLabel: {
                    kind: 'string',
                    required: false
                  },
                  legendLocation: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'LEFT',
                      'RIGHT',
                      'TOP'
                    ]
                  }
                }
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              type: {
                kind: 'string',
                required: true,
                value: 'BOX_PLOT'
              },
              parameters: {
                kind: 'shape',
                required: true,
                fields: {
                  xAxisColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  xAxisMin: {
                    kind: 'number',
                    required: false
                  },
                  xAxisMax: {
                    kind: 'number',
                    required: false
                  },
                  sortDirection: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'ASCENDING',
                      'DESCENDING'
                    ]
                  },
                  pointLabelColumnName: {
                    kind: 'columnReference',
                    required: false,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  yAxisColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  yAxisMin: {
                    kind: 'number',
                    required: false
                  },
                  yAxisMax: {
                    kind: 'number',
                    required: false
                  },
                  invertYAxis: {
                    kind: 'boolean',
                    required: false
                  },
                  seriesColumnName: {
                    kind: 'columnReference',
                    required: false,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  showPoints: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'ALL',
                      'OUTLIERS',
                      'HIDE'
                    ]
                  },
                  lineWidth: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'THIN',
                      'THICK',
                      'NONE'
                    ]
                  },
                  lineWidthOverride: {
                    kind: 'integer',
                    required: false
                  },
                  fillOpacity: {
                    kind: 'number',
                    required: false
                  },
                  fillNullsWithDefaultValues: {
                    kind: 'boolean',
                    required: false
                  },
                  annotationLineConfigs: {
                    kind: 'array',
                    required: false,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        intercept: {
                          kind: 'number',
                          required: false
                        },
                        slope: {
                          kind: 'number',
                          required: false
                        },
                        direction: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'HORIZONTAL',
                            'VERTICAL'
                          ]
                        },
                        columnName: {
                          kind: 'columnReference',
                          required: false,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        valueMode: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'MANUAL',
                            'FROM_COLUMN'
                          ]
                        },
                        color: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'WHITE',
                            'BLACK',
                            'GREEN',
                            'GRAY',
                            'BLUE'
                          ]
                        },
                        hexColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        dash: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'SOLID',
                            'DASH',
                            'DOT',
                            'DASHDOT'
                          ]
                        },
                        lineLabel: {
                          kind: 'string',
                          required: false
                        }
                      }
                    }
                  },
                  xAxisLabel: {
                    kind: 'string',
                    required: false
                  },
                  yAxisLabel: {
                    kind: 'string',
                    required: false
                  },
                  markerShape: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'CIRCLE',
                      'DIAMOND',
                      'SQUARE',
                      'CROSS',
                      'X'
                    ]
                  },
                  markerOpacity: {
                    kind: 'number',
                    required: false
                  },
                  markerShapeOpen: {
                    kind: 'boolean',
                    required: false
                  },
                  discreteColorPalette: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'BENCHLING',
                      'DARK24',
                      'LIGHT24',
                      'BOLD',
                      'PASTEL',
                      'SAFE',
                      'PRISM'
                    ]
                  },
                  seriesColorConfigs: {
                    kind: 'array',
                    required: false,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        series: {
                          kind: 'string',
                          required: false
                        },
                        color: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        borderColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        errorBarColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        }
                      }
                    }
                  },
                  showLegend: {
                    kind: 'boolean',
                    required: false
                  },
                  legendLabel: {
                    kind: 'string',
                    required: false
                  },
                  legendLocation: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'LEFT',
                      'RIGHT',
                      'TOP'
                    ]
                  }
                }
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              type: {
                kind: 'string',
                required: true,
                value: 'CONTOUR_PLOT'
              },
              parameters: {
                kind: 'shape',
                required: true,
                fields: {
                  colorScale: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'BLUE',
                      'BLUE_LIME',
                      'LAVA'
                    ]
                  },
                  gradientDirection: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'ASCENDING_METRIC_VALUES',
                      'DESCENDING_METRIC_VALUES'
                    ]
                  },
                  metricColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  metricLabel: {
                    kind: 'string',
                    required: false
                  },
                  scatterChartConfig: {
                    kind: 'shape',
                    required: false,
                    fields: {
                      colorPalette: {
                        kind: 'enum',
                        required: false,
                        choices: [
                          'BENCHLING',
                          'DARK24',
                          'LIGHT24',
                          'BOLD',
                          'PASTEL',
                          'SAFE',
                          'PRISM',
                          'VIRIDIS',
                          'PLASMA',
                          'BLUERED',
                          'HOT',
                          'BLUES',
                          'REDS'
                        ]
                      },
                      shapeSeriesColumnName: {
                        kind: 'columnReference',
                        required: false,
                        inputDataName: 'Input dataset',
                        validationOptions: null
                      },
                      pointLabelColumnName: {
                        kind: 'columnReference',
                        required: false,
                        inputDataName: 'Input dataset',
                        validationOptions: null
                      },
                      xAxisLabel: {
                        kind: 'string',
                        required: false
                      },
                      yAxisLabel: {
                        kind: 'string',
                        required: false
                      },
                      seriesColorConfigs: {
                        kind: 'array',
                        required: false,
                        elementSpec: {
                          kind: 'shape',
                          required: true,
                          fields: {
                            series: {
                              kind: 'string',
                              required: false
                            },
                            color: {
                              kind: 'color',
                              required: false,
                              pattern: '^#[A-Fa-f0-9]{6}$'
                            },
                            borderColor: {
                              kind: 'color',
                              required: false,
                              pattern: '^#[A-Fa-f0-9]{6}$'
                            },
                            errorBarColor: {
                              kind: 'color',
                              required: false,
                              pattern: '^#[A-Fa-f0-9]{6}$'
                            }
                          }
                        }
                      },
                      seriesShapeConfigs: {
                        kind: 'array',
                        required: false,
                        elementSpec: {
                          kind: 'shape',
                          required: true,
                          fields: {
                            seriesValue: {
                              kind: 'anything',
                              required: true
                            },
                            borderWidth: {
                              kind: 'integer',
                              required: false
                            },
                            markerShape: {
                              kind: 'enum',
                              required: false,
                              choices: [
                                'CIRCLE',
                                'DIAMOND',
                                'SQUARE',
                                'CROSS',
                                'X'
                              ]
                            },
                            markerSize: {
                              kind: 'integer',
                              required: false
                            }
                          }
                        }
                      },
                      trendlineType: {
                        kind: 'enum',
                        required: false,
                        choices: [
                          'OLS',
                          'LOWESS',
                          'EXPANDING'
                        ]
                      },
                      annotationLineConfigs: {
                        kind: 'array',
                        required: false,
                        elementSpec: {
                          kind: 'shape',
                          required: true,
                          fields: {
                            intercept: {
                              kind: 'number',
                              required: false
                            },
                            slope: {
                              kind: 'number',
                              required: false
                            },
                            direction: {
                              kind: 'enum',
                              required: false,
                              choices: [
                                'HORIZONTAL',
                                'VERTICAL'
                              ]
                            },
                            columnName: {
                              kind: 'columnReference',
                              required: false,
                              inputDataName: 'Input dataset',
                              validationOptions: null
                            },
                            valueMode: {
                              kind: 'enum',
                              required: false,
                              choices: [
                                'MANUAL',
                                'FROM_COLUMN'
                              ]
                            },
                            color: {
                              kind: 'enum',
                              required: false,
                              choices: [
                                'WHITE',
                                'BLACK',
                                'GREEN',
                                'GRAY',
                                'BLUE'
                              ]
                            },
                            hexColor: {
                              kind: 'color',
                              required: false,
                              pattern: '^#[A-Fa-f0-9]{6}$'
                            },
                            dash: {
                              kind: 'enum',
                              required: false,
                              choices: [
                                'SOLID',
                                'DASH',
                                'DOT',
                                'DASHDOT'
                              ]
                            },
                            lineLabel: {
                              kind: 'string',
                              required: false
                            }
                          }
                        }
                      }
                    }
                  },
                  xAxisColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  yAxisColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  showLegend: {
                    kind: 'boolean',
                    required: false
                  },
                  legendLabel: {
                    kind: 'string',
                    required: false
                  },
                  legendLocation: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'LEFT',
                      'RIGHT',
                      'TOP'
                    ]
                  }
                }
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              type: {
                kind: 'string',
                required: true,
                value: 'HEATMAP'
              },
              parameters: {
                kind: 'shape',
                required: true,
                fields: {
                  gradientColorPalette: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'VIRIDIS',
                      'PLASMA',
                      'BLUERED',
                      'HOT',
                      'BLUES',
                      'REDS'
                    ]
                  },
                  gradientDirection: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'ASCENDING_METRIC_VALUES',
                      'DESCENDING_METRIC_VALUES'
                    ]
                  },
                  metricColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  tryConvertStrings: {
                    kind: 'boolean',
                    required: false
                  },
                  fillNullsWithDefaultValues: {
                    kind: 'boolean',
                    required: false
                  },
                  xAxisColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  yAxisColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  showLegend: {
                    kind: 'boolean',
                    required: false
                  },
                  legendLabel: {
                    kind: 'string',
                    required: false
                  },
                  legendLocation: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'LEFT',
                      'RIGHT',
                      'TOP'
                    ]
                  }
                }
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              type: {
                kind: 'string',
                required: true,
                value: 'LINE_CHART'
              },
              parameters: {
                kind: 'shape',
                required: true,
                fields: {
                  pointLabelColumnName: {
                    kind: 'columnReference',
                    required: false,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  annotationLineConfigs: {
                    kind: 'array',
                    required: false,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        intercept: {
                          kind: 'number',
                          required: false
                        },
                        slope: {
                          kind: 'number',
                          required: false
                        },
                        direction: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'HORIZONTAL',
                            'VERTICAL'
                          ]
                        },
                        columnName: {
                          kind: 'columnReference',
                          required: false,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        valueMode: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'MANUAL',
                            'FROM_COLUMN'
                          ]
                        },
                        color: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'WHITE',
                            'BLACK',
                            'GREEN',
                            'GRAY',
                            'BLUE'
                          ]
                        },
                        hexColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        dash: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'SOLID',
                            'DASH',
                            'DOT',
                            'DASHDOT'
                          ]
                        },
                        lineLabel: {
                          kind: 'string',
                          required: false
                        }
                      }
                    }
                  },
                  xAxisColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  xAxisScale: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'LINEAR',
                      'LOG'
                    ]
                  },
                  yAxisColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  yAxisScale: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'LINEAR',
                      'LOG'
                    ]
                  },
                  yAxisIncludesZero: {
                    kind: 'boolean',
                    required: true
                  },
                  xAxisMin: {
                    kind: 'number',
                    required: false
                  },
                  xAxisMax: {
                    kind: 'number',
                    required: false
                  },
                  yAxisMin: {
                    kind: 'number',
                    required: false
                  },
                  yAxisMax: {
                    kind: 'number',
                    required: false
                  },
                  xAxisLabel: {
                    kind: 'string',
                    required: false
                  },
                  yAxisLabel: {
                    kind: 'string',
                    required: false
                  },
                  markerShape: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'CIRCLE',
                      'DIAMOND',
                      'SQUARE',
                      'CROSS',
                      'X'
                    ]
                  },
                  markerOpacity: {
                    kind: 'number',
                    required: false
                  },
                  markerShapeOpen: {
                    kind: 'boolean',
                    required: false
                  },
                  discreteColorPalette: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'BENCHLING',
                      'DARK24',
                      'LIGHT24',
                      'BOLD',
                      'PASTEL',
                      'SAFE',
                      'PRISM'
                    ]
                  },
                  seriesColorConfigs: {
                    kind: 'array',
                    required: false,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        series: {
                          kind: 'string',
                          required: false
                        },
                        color: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        borderColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        errorBarColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        }
                      }
                    }
                  },
                  seriesColumnName: {
                    kind: 'columnReference',
                    required: false,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  tryConvertStrings: {
                    kind: 'boolean',
                    required: false
                  },
                  fillNullsWithDefaultValues: {
                    kind: 'boolean',
                    required: false
                  },
                  errorBarColumnName: {
                    kind: 'columnReference',
                    required: false,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  showLegend: {
                    kind: 'boolean',
                    required: false
                  },
                  legendLabel: {
                    kind: 'string',
                    required: false
                  },
                  legendLocation: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'LEFT',
                      'RIGHT',
                      'TOP'
                    ]
                  }
                }
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              type: {
                kind: 'string',
                required: true,
                value: 'SCATTER_PLOT'
              },
              parameters: {
                kind: 'shape',
                required: true,
                fields: {
                  colorPalette: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'BENCHLING',
                      'DARK24',
                      'LIGHT24',
                      'BOLD',
                      'PASTEL',
                      'SAFE',
                      'PRISM',
                      'VIRIDIS',
                      'PLASMA',
                      'BLUERED',
                      'HOT',
                      'BLUES',
                      'REDS'
                    ]
                  },
                  shapeSeriesColumnName: {
                    kind: 'columnReference',
                    required: false,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  pointLabelColumnName: {
                    kind: 'columnReference',
                    required: false,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  xAxisLabel: {
                    kind: 'string',
                    required: false
                  },
                  yAxisLabel: {
                    kind: 'string',
                    required: false
                  },
                  seriesColorConfigs: {
                    kind: 'array',
                    required: false,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        series: {
                          kind: 'string',
                          required: false
                        },
                        color: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        borderColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        errorBarColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        }
                      }
                    }
                  },
                  seriesShapeConfigs: {
                    kind: 'array',
                    required: false,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        seriesValue: {
                          kind: 'anything',
                          required: true
                        },
                        borderWidth: {
                          kind: 'integer',
                          required: false
                        },
                        markerShape: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'CIRCLE',
                            'DIAMOND',
                            'SQUARE',
                            'CROSS',
                            'X'
                          ]
                        },
                        markerSize: {
                          kind: 'integer',
                          required: false
                        }
                      }
                    }
                  },
                  trendlineType: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'OLS',
                      'LOWESS',
                      'EXPANDING'
                    ]
                  },
                  annotationLineConfigs: {
                    kind: 'array',
                    required: false,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        intercept: {
                          kind: 'number',
                          required: false
                        },
                        slope: {
                          kind: 'number',
                          required: false
                        },
                        direction: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'HORIZONTAL',
                            'VERTICAL'
                          ]
                        },
                        columnName: {
                          kind: 'columnReference',
                          required: false,
                          inputDataName: 'Input dataset',
                          validationOptions: null
                        },
                        valueMode: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'MANUAL',
                            'FROM_COLUMN'
                          ]
                        },
                        color: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'WHITE',
                            'BLACK',
                            'GREEN',
                            'GRAY',
                            'BLUE'
                          ]
                        },
                        hexColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        dash: {
                          kind: 'enum',
                          required: false,
                          choices: [
                            'SOLID',
                            'DASH',
                            'DOT',
                            'DASHDOT'
                          ]
                        },
                        lineLabel: {
                          kind: 'string',
                          required: false
                        }
                      }
                    }
                  },
                  xAxisColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  xAxisScale: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'LINEAR',
                      'LOG'
                    ]
                  },
                  yAxisColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  yAxisScale: {
                    kind: 'enum',
                    required: true,
                    choices: [
                      'LINEAR',
                      'LOG'
                    ]
                  },
                  yAxisIncludesZero: {
                    kind: 'boolean',
                    required: true
                  },
                  xAxisMin: {
                    kind: 'number',
                    required: false
                  },
                  xAxisMax: {
                    kind: 'number',
                    required: false
                  },
                  yAxisMin: {
                    kind: 'number',
                    required: false
                  },
                  yAxisMax: {
                    kind: 'number',
                    required: false
                  },
                  markerShape: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'CIRCLE',
                      'DIAMOND',
                      'SQUARE',
                      'CROSS',
                      'X'
                    ]
                  },
                  markerOpacity: {
                    kind: 'number',
                    required: false
                  },
                  markerShapeOpen: {
                    kind: 'boolean',
                    required: false
                  },
                  seriesColumnName: {
                    kind: 'columnReference',
                    required: false,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  tryConvertStrings: {
                    kind: 'boolean',
                    required: false
                  },
                  fillNullsWithDefaultValues: {
                    kind: 'boolean',
                    required: false
                  },
                  errorBarColumnName: {
                    kind: 'columnReference',
                    required: false,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  showLegend: {
                    kind: 'boolean',
                    required: false
                  },
                  legendLabel: {
                    kind: 'string',
                    required: false
                  },
                  legendLocation: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'LEFT',
                      'RIGHT',
                      'TOP'
                    ]
                  }
                }
              }
            }
          },
          {
            kind: 'shape',
            required: true,
            fields: {
              type: {
                kind: 'string',
                required: true,
                value: 'PIE_CHART'
              },
              parameters: {
                kind: 'shape',
                required: true,
                fields: {
                  measureColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  showPercentageInLabel: {
                    kind: 'boolean',
                    required: true
                  },
                  showSliceNameInLabel: {
                    kind: 'boolean',
                    required: true
                  },
                  showValueInLabel: {
                    kind: 'boolean',
                    required: true
                  },
                  sliceColumnName: {
                    kind: 'columnReference',
                    required: true,
                    inputDataName: 'Input dataset',
                    validationOptions: null
                  },
                  tryConvertStrings: {
                    kind: 'boolean',
                    required: false
                  },
                  fillNullsWithDefaultValues: {
                    kind: 'boolean',
                    required: false
                  },
                  discreteColorPalette: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'BENCHLING',
                      'DARK24',
                      'LIGHT24',
                      'BOLD',
                      'PASTEL',
                      'SAFE',
                      'PRISM'
                    ]
                  },
                  seriesColorConfigs: {
                    kind: 'array',
                    required: false,
                    elementSpec: {
                      kind: 'shape',
                      required: true,
                      fields: {
                        series: {
                          kind: 'string',
                          required: false
                        },
                        color: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        borderColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        },
                        errorBarColor: {
                          kind: 'color',
                          required: false,
                          pattern: '^#[A-Fa-f0-9]{6}$'
                        }
                      }
                    }
                  },
                  showLegend: {
                    kind: 'boolean',
                    required: false
                  },
                  legendLabel: {
                    kind: 'string',
                    required: false
                  },
                  legendLocation: {
                    kind: 'enum',
                    required: false,
                    choices: [
                      'LEFT',
                      'RIGHT',
                      'TOP'
                    ]
                  }
                }
              }
            }
          }
        ]
      },
      chartName: {
        kind: 'string',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
